var map = {
	"./AdDojo.png": 298,
	"./EdgeDetection.png": 363,
	"./FinancialModel.png": 394,
	"./Fitness-Freak.png": 790,
	"./KnowledgeGraph.png": 859,
	"./LyricFinder.png": 413,
	"./NLP.png": 882,
	"./Object-Detection.png": 776,
	"./OneVote.png": 540,
	"./Othello.png": 133,
	"./Portfolio.png": 992,
	"./Tunesphere.png": 29,
	"./UnbiasedLLMs.png": 311
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 895;